import WithRender from "../../templates/containers/uploadContainer.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters([
      "getShowUpload",
      "getProductPartsNames",
      "getForceDisablePersonalization"
    ])
  },
  props: ["hideContainer", "alwaysShow"]
});
